<!-- frontend/src/App.vue -->
<template>
  <v-app>
    <v-main>
      <div v-if="shouldShowLayout" class="flex h-screen bg-gray-100">
        <AppSidebar v-model="isSidebarOpen" :is-mobile-menu-open="isMobileMenuOpen"
          @update:is-mobile-menu-open="isMobileMenuOpen = $event" />
        <div class="flex-1 flex flex-col overflow-hidden">
          <AppHeader :title="currentPageTitle" :notification-count="unreadNotifications" :notifications="notifications"
            :show-notifications="showNotifications" @toggle-notifications="toggleNotifications"
            @toggle-mobile-sidebar="toggleMobileMenu" @notification-click="handleNotificationClick"
            @title-click="goToHome" />
          <main class="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100">
            <router-view></router-view>
          </main>
        </div>
      </div>
      <router-view v-else></router-view>
    </v-main>
  </v-app>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
// 절대 경로로 수정
import AppSidebar from '@/components/layout/AppSidebar.vue'
import AppHeader from '@/components/layout/AppHeader.vue'

const route = useRoute()
const router = useRouter()

// 알림 관련 상태
const notifications = ref([
  /*{ 
    id: 1, 
    message: '[에뜨와] 2월 2차 연출공지에 대한 담당자 답변이 등록되었습니다.', 
    date: '2025-02-23', 
    isRead: false 
  },
  { 
    id: 2, 
    message: '[아가방] VMD 요청사항 제출 기한이 임박했습니다.', 
    date: '2025-02-22', 
    isRead: false 
  },
  { 
    id: 3, 
    message: '새로운 공지사항이 등록되었습니다.', 
    date: '2025-02-21', 
    isRead: true 
  }*/
]);

const showNotifications = ref(false);
const unreadNotifications = computed(() => {
  return notifications.value.filter(n => !n.isRead).length;
});

// 알림 클릭 처리 함수 수정
const handleNotificationClick = (notification) => {
    if (!notification.isRead) {
        notification.isRead = true;
    }
    // 홈으로 이동
    router.push('/');
    showNotifications.value = false;
};

const toggleNotifications = () => {
  showNotifications.value = !showNotifications.value;
};

const isSidebarOpen = ref(true)
const isMobileMenuOpen = ref(false)

// 레이아웃을 표시하지 않을 라우트 목록 수정
const layoutExcludedRoutes = ['Login', 'NotFound', 'ForgotPassword', 'ResetPassword', 'Select']

// 전체 레이아웃 표시 여부
const shouldShowLayout = computed(() => {
  return !layoutExcludedRoutes.includes(route.name)
})

// 홈으로 이동하는 함수 추가
const goToHome = () => {
  router.push('/');
};

// 현재 페이지 제목 설정 - 모든 페이지에서 '매장관리웹'으로 통일
const currentPageTitle = computed(() => {
  return '홈';
});

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

body {
  font-family: 'Inter', sans-serif;
}

/* Custom color for Tailwind */
:root {
  --color-blue-700: #0066B3;
  --color-blue-800: #005A9E;
  --color-blue-900: #004F8A;
}

/* Override Tailwind classes */
.bg-blue-700 {
  background-color: var(--color-blue-700);
}

.bg-blue-800 {
  background-color: var(--color-blue-800);
}

.bg-blue-900 {
  background-color: var(--color-blue-900);
}

.text-blue-700 {
  color: var(--color-blue-700);
}

.from-blue-700 {
  --tw-gradient-from: var(--color-blue-700);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(0, 102, 179, 0));
}

.to-blue-900 {
  --tw-gradient-to: var(--color-blue-900);
}

.hover\:bg-blue-800:hover {
  background-color: var(--color-blue-800);
}

/* 모바일 메뉴가 열렸을 때 스크롤 방지 */
.overflow-hidden {
  overflow: hidden;
}
</style>
